module.exports = "assets/c532b6bd0051acffecafef8a3eb81772.glb";